module.exports = __webpack_public_path__ + "img/制御工学3_6_4.797c8b16.png";